import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as api from "../../api";
import LoadingSpinner from "../../storybook/LoadingSpinner";
import "./index.scss";
import { RouteComponentProps } from "react-router-dom";
import { AssocitaedAssetsType } from "../../models/Property/AdminUnits";
import Tenancies from "../../models/Customer/Tenancies";
import { CustomerResponse } from "../../models/Customer";
import {
  userChosenPropertyAddress,
  userChosenBalance,
  userChosenAccountNumber,
  userChosenBalanceType,
  userChosenAccountType,
  viewStatementData,
  userChosenAccountIdentifier,
  showMenuTabs,
} from "../../ducks/redux/actions/userChoices";
import { BalanceType } from "../../models/Accounts/BalanceType";
import AccountDetails from "../../models/Accounts/AccountDetails";
import {
  AccountType,
  AccountTypeList,
  getAccountType,
} from "../../models/Accounts/AccountType";
import {
  formatDateWithFullMonthInLetters,
  isNullOrUndefined,
  detectMobile,
  formatDateTimeSlash
} from "../../utils/formatting";
import TransactionDetails from "../TransactionDetails/index";
import ViewStatement from "../ViewStatement/index";
import Message from "../../storybook/Message";
import moment from "moment";
interface ViewAccountProps extends RouteComponentProps<any> { }
const ViewAccount: React.FC<ViewAccountProps> = (props) => {
  const dispatch = useDispatch();
  let PropertyId = useSelector(
    (state: any) => state.userChoicesReducer.userChosenPropertyId
  );
  const [defaultassocitaedAsset, setdefaultassocitaedAsset] = useState("");
  const [defaultAccount, setdefaultAccount] = useState("");
  const [selectedAccount, setSelectedAccount] = useState<AccountDetails | null>(
    null
  );
  let [hasRestrictedSubtype, setHasRestrictedSubtype] = useState(false);
  const [isApiFail, setApiFailMessage] = useState(false);
  const [payref, setpayref] = useState("");
  const [Area, setArea] = useState(false);
  const [multipleAccunt, setMultipleAccount] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const arrayArea: Array<{ key: string; value: string }> = [];
  const array: AccountDetails[] = [];
  const account: any[] = [];
  const [accountResponse, setaccountCustomerResponse] = useState(account);
  const [accountdetails, setaccountdetails] = useState(array);
  const [associtaedAssetList, setassocitaedAssetsList] = useState(arrayArea);
  const [CustResponse, setCustomerResponse] = useState<CustomerResponse>();
  const [tenancySummary, setTenancySummary] = useState<any>();
  const [isViewStatement, setIsViewStatement] = React.useState("");
  const[renError, setRenError]=useState(false);
  const [selectedAccountType, setSelectedAccountType] = useState<string>("");
  const isMobile = detectMobile();
  const customerID = useSelector((state: any) => state.addresses?.customerid);
  const { t } = useTranslation();
  let associtaedAssets: any[] = [];
  const directDebitAllowedAccountTypes = useSelector(
    (state: any) => state.userChoicesReducer?.directDebitAllowedAccountTypes
  );
  const DDToggle = useSelector((state: any) => state.userChoicesReducer?.directDebitToggle);
  const hasUCFlag= useSelector(
    (state: any) => state.financialReferralReducer?.isUCFlag)

  const RESTRICTED_SUBTYPES = new Set([
    "HBD",
    "HBPST",
    "HBREC",
    "UCP",
    "HBPST~PAY",
    "HBD~PAY",
    "UCP~PAY",
  ]);

const getAllowedDirectDebitTypes = (): string[] => {
    if (Array.isArray(directDebitAllowedAccountTypes)) {
      return directDebitAllowedAccountTypes.filter(Boolean);
    }
    return directDebitAllowedAccountTypes ? [directDebitAllowedAccountTypes] : [];
  };
const getAccountTypeDetailForRestriction = async () => {
  try {
          const mmntTo = moment(new Date());
          const datetoValue = formatDateTimeSlash(mmntTo.toString());
          const mmntFrom = moment(new Date()).subtract(6, 'weeks');
          const datefromValue = formatDateTimeSlash(mmntFrom.toString());
          if (selectedAccount?.Payref) {
          const transactionDetails = await api.getTransactionsSearch(
          selectedAccount?.Payref,
          10,
          0,
          datefromValue,
          datetoValue,
          "",
          "All"
        );
        if (transactionDetails?.totalCount > 0) {
          const hasRestricted = transactionDetails.transactions.some((element: any) =>
            RESTRICTED_SUBTYPES.has(element["transaction-subtype"]?.["sub-type"])
          );
          setHasRestrictedSubtype(hasRestricted);
        }
      } 

  } catch (error) {
    console.error("Error fetching account type details:", error);
  }
}

  const getViewStatementFlag = async () => {
     try {
        const response = await api.GetAppConfigToggleValue("IsViewStatement");
        setIsViewStatement(response?.value);
      } catch (e: any) {
        console.log("error", e);
      }
  }

  useEffect(() => {
    dispatch(showMenuTabs(true));
    getViewStatementFlag();
    getAccountTypeDetailForRestriction()
  }, [selectedAccount?.Payref]);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(false);
        const customerResponse = await api.getCustomer(customerID);
        const accountCustomerResponse = await api.getAccountByCustomers(
          customerID
        );
        
        setaccountCustomerResponse(accountCustomerResponse);
        setCustomerResponse(customerResponse);
        const activeTenanciesSummaries =
          customerResponse.tenanciesSummaries.filter(
            (ts) =>
              ts.tenancySummary.statuses.find(
                (s) => s.type === "isTenancyActive"
              )?.value === true
          );
        const activeTenanciesPremisesIds: Tenancies[] = activeTenanciesSummaries
          .map((ts: any) => ts.tenancySummary.premisesIds)
          .flat();
        const promises = activeTenanciesPremisesIds.map((item: any) => {
          return api.getAssociatedAssets(item).catch((error) => {
            setIsLoading(false)
            setApiFailMessage(true);
        });
        });
        Promise.all(promises).then((results) => {
          activeTenanciesPremisesIds?.map(async (assetid: any) => {
            results.forEach((element:any) => {
              const resultF = element.filter(
                (addressdata:any) => addressdata.id === assetid
              );

              if (resultF !== null) associtaedAssets.push(resultF);
            });
          });
          const associtaedAssetsList: AssocitaedAssetsType[] = [];

          associtaedAssets?.map((addressdata: any) => {
            addressdata?.map((address: any) => {
              const associtaedAssetsTypeEntry: AssocitaedAssetsType =
                new AssocitaedAssetsType();

              associtaedAssetsTypeEntry.key = address?.id;
              associtaedAssetsTypeEntry.value =
                address?.addresses?.postalAddresses[0]?.formattedAddress;
              associtaedAssetsList.push(associtaedAssetsTypeEntry);
            });
          });
          if (associtaedAssetsList.length > 1) {
            setArea(true);
          } else {
            setArea(false);
          }
          if (PropertyId != "") {
            setdefaultassocitaedAsset(PropertyId);
          } else {
            PropertyId = associtaedAssetsList[0]?.key;
            setdefaultassocitaedAsset(associtaedAssetsList[0]?.key);
          }
          if (
            activeTenanciesSummaries != undefined &&
            activeTenanciesSummaries != null
          ) {
            let tenancySummaryEntry = activeTenanciesSummaries.find(
              (st) => st.tenancySummary.premisesIds[0] === PropertyId
            );
            setTenancySummary(tenancySummaryEntry);
            if (
              tenancySummaryEntry != undefined &&
              tenancySummaryEntry != null
            ) {
              let paymentReference =
                tenancySummaryEntry?.tenancySummary?.paymentReference;
              if (paymentReference != undefined && paymentReference != null) {
                getAccountList(paymentReference, accountCustomerResponse);
              }
            }
          }
          setassocitaedAssetsList(associtaedAssetsList);
          const propety = associtaedAssetsList.filter(
            (x) => x.key === PropertyId
          );
          dispatch(userChosenPropertyAddress(propety[0]?.value));
        });
      } catch (e) {
        setIsLoading(true);
        setApiFailMessage(true);
        console.error(e);
      }
    })();
  }, []);

  useEffect(() => {
    if (defaultAccount && accountResponse.length > 0) {
      const selectedAccountFromResponse = accountResponse.find(
        (account: any) => account['account-identifier'] === defaultAccount
      );
      if (selectedAccountFromResponse) {
        setSelectedAccountType(selectedAccountFromResponse['account-type']);
      }
    }
  }, [defaultAccount, accountResponse]);

  const backButtonHandler = () => {
    props.history.push("/customer360View");
  };
  const callPageHandler = async (
    AccountNumber: string | null,
    Payref: string | null,
    AccountType: string | null,
    LiveBalance: string,
    LiveBalanceType: string | null
  ) => {
    let LiveBalanceValue = "£" + LiveBalance;
    dispatch(userChosenBalanceType(LiveBalanceType));
    dispatch(userChosenAccountNumber(Payref));
    dispatch(userChosenBalance(LiveBalanceValue));
    dispatch(userChosenAccountType(AccountType));

    props.history.push("/transactionDetails");
  };

  const viewStatementHandler = (
    Payref: string | null,
    AccountType: string | null,
    AccountNumber: string | null
  ) => {
    dispatch(userChosenAccountNumber(Payref));
    dispatch(userChosenAccountType(AccountType));
    dispatch(userChosenAccountIdentifier(AccountNumber));
    const currentAccount = accountResponse.filter(
      (el) => el["account-identifier"] === Payref
    );

    const statementData = {
      tenancyStartDate: tenancySummary.tenancySummary?.tenancyStartDate,
      currentAccount: currentAccount,
      getCustomerResponse: CustResponse,
    };
    dispatch(viewStatementData(statementData));
    props.history.push("/viewstatement");
  };

  const callPageHandlerPayment = async (
    AccountNumber: string | null,
    Payref: string | null,
    AccountType: string | null,
    LiveBalance: string,
    LiveBalanceType: string | null
  ) => {
    dispatch(userChosenBalanceType(LiveBalanceType));
    dispatch(userChosenAccountNumber(Payref));
    if (LiveBalanceType === "in Credit") {
      dispatch(userChosenBalance(0.0));
    } else {
      dispatch(userChosenBalance(Number(LiveBalance).toFixed(2)));
    }
    dispatch(userChosenAccountType(AccountType));

    props.history.push("/paymentDetails");
  };
  const handleChangeAssocitae = (e: { target: { value: any } }) => {
    setdefaultassocitaedAsset(e.target.value);
    const activeTenanciesSummaries = CustResponse?.tenanciesSummaries.filter(
      (ts) =>
        ts.tenancySummary.statuses.find((s) => s.type === "isTenancyActive")
          ?.value === true
    );

    if (
      activeTenanciesSummaries != undefined &&
      activeTenanciesSummaries != null
    ) {
      let TenancySummaryEntry = activeTenanciesSummaries.find(
        (st) => st.tenancySummary.premisesIds[0] === e.target.value
      );
      setTenancySummary(TenancySummaryEntry);
      if (TenancySummaryEntry != undefined && TenancySummaryEntry != null) {
        let paymentReference =
          TenancySummaryEntry?.tenancySummary?.paymentReference;
        if (paymentReference != undefined && paymentReference != null) {
          getAccountList(paymentReference, accountResponse);
        }
      }
    }
    const property = associtaedAssetList.filter(
      (x) => x.key === e.target.value
    );
    dispatch(userChosenPropertyAddress(property[0]?.value));
  };

  const handleChangeAccount = (e: { target: { value: any } }) => {
    setdefaultAccount(e.target.value);
    const chnagedAccountDetails = accountdetails.find(
      (account) => account.AccountNumber === e.target.value
    );
    setSelectedAccount(chnagedAccountDetails);
    setRenError(false);
    setHasRestrictedSubtype(false);
    const selectedAccountFromResponse = accountResponse.find(
      (account: any) => account['account-identifier'] === e.target.value
    );
    if (selectedAccountFromResponse) {
      setSelectedAccountType(selectedAccountFromResponse['account-type']);
    }
  };

  const getAccountList = (accountid: string, accountResponse: any) => {
    const accountDetailsList: AccountDetails[] = [];
    let orderAccountDetailsList: AccountDetails[] = [];
    accountResponse.forEach((accountBalance: any) => {
      const accountDetails: AccountDetails = new AccountDetails();
      if (
        accountBalance.identifiers["pay-ref"].substring(0, 6) == accountid ||
        accountBalance.identifiers["pay-ref"].substring(0, 7) == accountid
      ) {
        setpayref(accountBalance.identifiers["pay-ref"]);
        if (accountBalance["account-type"] === AccountTypeList.REN) {
          accountDetails.DisplayNumber = 1;
          accountDetails.AccountType = getAccountType(
            AccountTypeList.REN,
            accountBalance["tenancy-type"]
          );
          accountDetails.Payref = accountBalance.identifiers["pay-ref"];
        } else if (accountBalance["account-type"] === AccountTypeList.FD5) {
          accountDetails.DisplayNumber = 2;
          accountDetails.AccountType = getAccountType(
            AccountTypeList.FD5,
            accountBalance["tenancy-type"]
          );
          accountDetails.Payref = accountBalance.identifiers["pay-ref"];
        } else if (accountBalance["account-type"] === AccountTypeList.MJW) {
          accountDetails.DisplayNumber = 3;
          accountDetails.AccountType = getAccountType(
            AccountTypeList.MJW,
            accountBalance["tenancy-type"]
          );
          accountDetails.Payref = accountBalance.identifiers["pay-ref"];
        } else if (accountBalance["account-type"] === AccountTypeList.GRD) {
          accountDetails.DisplayNumber = 4;
          accountDetails.Payref = accountBalance.identifiers["pay-ref"];
          accountDetails.AccountType = getAccountType(
            AccountTypeList.GRD,
            accountBalance["tenancy-type"]
          );
        } else if (accountBalance["account-type"] === AccountTypeList.DEP) {
          accountDetails.DisplayNumber = 5;
          accountDetails.AccountType = getAccountType(
            AccountTypeList.DEP,
            accountBalance["tenancy-type"]
          );
          accountDetails.Payref = accountBalance.identifiers["pay-ref"];
        } else if (accountBalance["account-type"] === AccountTypeList.HOM) {
          accountDetails.DisplayNumber = 6;
          accountDetails.AccountType = getAccountType(
            AccountTypeList.HOM,
            accountBalance["tenancy-type"]
          );
          accountDetails.Payref = accountBalance.identifiers["pay-ref"];
        }
        accountDetails.AccountNumber = accountBalance["account-identifier"];
        accountDetails.lastTransactionBalance =
          accountBalance["last-transaction"]?.amount?.gross?.value != null
            ? accountBalance["last-transaction"]?.amount?.gross?.value
            : 0.0;
        accountDetails.lastTransactionDate =
          accountBalance["last-transaction"]?.dates["created-date"];
        accountBalance["balance"].forEach((balance: any) => {
  if (balance["balance-type"] == BalanceType.Livebalanced) {
    let liveBalanced = balance["monetary-amount"]["value"];
    const accountBalanceValue = parseInt(liveBalanced);
    accountDetails.LiveBalanceType =
      accountBalanceValue != null
        ? accountBalanceValue > 0
          ? "in arrears"
          : "in Credit"
        : "";
    let number =
      liveBalanced != null
        ? Math.abs(liveBalanced.toString().replace(/,/g, ""))
        : 0.0;
    accountDetails.LiveBalance = number.toFixed(2);
    dispatch(userChosenBalance(`${accountDetails.LiveBalance} ${accountDetails.LiveBalanceType}`));
    if (liveBalanced == 0) {
      accountDetails.LiveBalanceType = "";
    }
    accountDetailsList.push(accountDetails);
       }
     });
      }
    });
    orderAccountDetailsList = accountDetailsList.filter(
      (x) => x.DisplayNumber != 0
    );

    const sortedAccountList = orderAccountDetailsList.sort((a, b) => {
      return a.DisplayNumber - b.DisplayNumber;
    });
    if (sortedAccountList?.length > 1) {
      setMultipleAccount(true);
    }
    setdefaultAccount(sortedAccountList[0]?.AccountNumber);
    setSelectedAccount(sortedAccountList[0]);
    setaccountdetails(sortedAccountList);
    setIsLoading(true);
  };
  const returnToHome = () => {
    props.history.push("/customer360View");
  };
  const openDialer = () => {
    window.open("tel:"+t("phone_no"));
}
  const handleDirectDebitSetup = () => {
  const allowedTypes = getAllowedDirectDebitTypes();
  const isAllowedType = allowedTypes.includes(selectedAccountType);
  const isBlocked = !isAllowedType || hasRestrictedSubtype || hasUCFlag;

  if (isBlocked) {
    setRenError(true);
    return;
  }

  props.history.push("/setupdirectdebit");
  setRenError(false);
};

  
  const getAccountAllDetails = useCallback(() => {
    if (isApiFail) {
     return (
             <>
             <div>
             <div
               id="div_apifail"
               className="alertpayment alert-warningpayment error-reason mar-left global-txt"
               role="alert"
             >
                <Message className="error-msg">{t("account_Down_SSC001")} <span>{t("phone_no")}</span>  <div onKeyDown={returnToHome} onClick={returnToHome} className="underline cursor-pointer">{t("Return_to_Home")}</div></Message>
             </div>
             </div>
             <div>
             <div
               id="div_apifail"
               className="alertpayment alert-warningpayment error-reason mar-left global-txt"
               role="alert"
             >
                <Message className="error-msg">{t("account_Down_SSC001")} <span className='underline' onKeyDown={openDialer} onClick={openDialer}>{t("phone_no")}</span>  <div onKeyDown={returnToHome} onClick={returnToHome} className="underline cursor-pointer">{t("Return_to_Home")}</div></Message>
             </div>
             </div>
             {selectedAccount?.AccountType != AccountType.DEP &&
                   isViewStatement === "true" && (
                     <>
                       <hr></hr>
                       <div className="mb-4">
                         <ViewStatement
                           Payref={selectedAccount?.Payref}
                           accountType={selectedAccount?.AccountType}
                           accountnumber={selectedAccount?.AccountNumber}
                         ></ViewStatement>
                       </div>
                     </>
                   )}
     
                 <hr></hr>
     
                 <div className="mb-4">
                   <TransactionDetails
                     accountType={selectedAccount?.AccountType}
                     accountnumber={selectedAccount?.Payref}
                     balance={selectedAccount?.LiveBalance}
                     balancetype={selectedAccount?.LiveBalanceType}
                   ></TransactionDetails>
                 </div>
             </>
           );
    } else {
      if (selectedAccount) {
        return (
          <div className="mb-8  py-2">
            <div className="py-2 grid grid-cols-1 md:grid-cols-5  gap-2">
              <div className="mb-2">
                <strong>{t("Balance")}</strong>
                <span
                  className={
                    selectedAccount?.LiveBalanceType === "in arrears"
                      ? "error-color"
                      : "color-black"
                  }
                >
                  <br /> £{selectedAccount?.LiveBalance}{" "}
                  {selectedAccount?.LiveBalanceType}
                </span>
              </div>

              <div className="mb-2 global-txt">
                <strong>{t("Last_Payment_amount")}</strong>
                <br /> £{selectedAccount?.lastTransactionBalance}
              </div>

              <div className="mb-2 global-txt">
                <strong data-testid="account-type-title">
                  {t("Account_Type")}
                </strong>
                <br /> {selectedAccount?.AccountType}
              </div>

              <div className="mb-2 global-txt">
                <strong>{t("Last_Payment_date")}</strong>
                <br />{" "}
                {isNullOrUndefined(selectedAccount?.lastTransactionDate)
                  ? "-"
                  : formatDateWithFullMonthInLetters(
                    selectedAccount?.lastTransactionDate
                  )}{" "}
              </div>
              {!multipleAccunt && (
                <div className="mb-2 global-txt">
                  <strong>{t("Account_number")}</strong>
                  <br /> {selectedAccount?.Payref}
                </div>
              )
              }

            </div>

            {selectedAccount?.AccountType != AccountType.DEP &&
              isViewStatement === "true" && (
                <>
                  <hr></hr>
                  <div className="mb-4">
                    <ViewStatement
                      Payref={selectedAccount?.Payref}
                      accountType={selectedAccount?.AccountType}
                      accountnumber={selectedAccount?.AccountNumber}
                    ></ViewStatement>
                  </div>
                </>
              )}

            <hr></hr>

            <div className="mb-4">
              <TransactionDetails
                accountType={selectedAccount?.AccountType}
                accountnumber={selectedAccount?.Payref}
                balance={selectedAccount?.LiveBalance}
                balancetype={selectedAccount?.LiveBalanceType}
              ></TransactionDetails>
            </div>
          </div>
        );
      } else {
       return (
                 <div>
                 <div
                 id="div_apifail"
                 className="alertpayment alert-warningpayment error-reason mar-left global-txt"
                 role="alert"
               >
                 {isMobile ? (<Message className="error-msg">{t("account_Down_SSC001")} <span tabIndex={0} aria-hidden="true" className='underline' onKeyDown={openDialer} onClick={openDialer}>{t("phone_no")}</span><br></br><br></br><span aria-hidden="true" onKeyDown={returnToHome} onClick={returnToHome} className="underline cursor-pointer">{t("Return_to_Home")}</span></Message>):( <Message className="error-msg">{t("account_Down_SSC001")} <span>{t("phone_no")}</span><br></br><br></br><span aria-hidden="true" tabIndex={0} onKeyDown={returnToHome} onClick={returnToHome} className="underline cursor-pointer">{t("Return_to_Home")}</span></Message>)}
               </div>
               <hr></hr>
                         <div className="mb-4">
                           <ViewStatement
                     
                           ></ViewStatement>
                         </div>
                         <hr></hr>
       
                   <div className="mb-4">
                     <TransactionDetails
                     ></TransactionDetails>
                   </div>
                 </div>
               );
      }
    }
  }, [selectedAccount, isApiFail, isViewStatement, multipleAccunt, isMobile, t]);

  return (
    <>
      {isLoading ? (
        <div className="padding-repair container-fluid">
          <div className="balance-container mt-24">
            <div className="balance-header">
              <h1>{t("Balance_Header")}</h1>
            </div>
            <div className="balance-buttons">
              {!isApiFail ? (
                <div>
                  {directDebitAllowedAccountTypes&& DDToggle &&(
                    <a
                      onClick={handleDirectDebitSetup}
                      onKeyDown={handleDirectDebitSetup}
                      className="secondary-ghost-btn mr-16"
                      id="Create-direct"
                      data-testid={
                        "Create-direct" + selectedAccount?.DisplayNumber
                      }
                    >
                      {" "}
                      {t("Create_direct_debit")}{" "}
                    </a>
                  )}

                  {selectedAccount?.AccountType != AccountType.DEP ? (
                    <a
                      href="#"
                      onClick={(event) =>
                        callPageHandlerPayment(
                          selectedAccount?.AccountNumber,
                          selectedAccount?.Payref,
                          selectedAccount?.AccountType,
                          selectedAccount?.LiveBalance,
                          selectedAccount?.LiveBalanceType
                        )
                      }
                      className="primary-btn"
                      id="make-Payment"
                      data-testid="make-Payment"
                    >
                      {" "}
                      {t("make_Payment")}{" "}
                    </a>
                  ) : (
                    <div></div>
                  )}
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </div>

          <div>
            {Area ? (
              <div className="search-addressdd">
                <select
                  data-testid="viewaccount-search-address"
                  value={defaultassocitaedAsset}
                  id="viewaccount-address"
                  className="text-select"
                  onChange={handleChangeAssocitae}
                >
                  {associtaedAssetList.map((e, key) => {
                    return (
                      <option key={key} value={e.key}>
                        {" "}
                        {e.value}
                      </option>
                    );
                  })}
                </select>
              </div>
            ) : (
              !isApiFail ?  <div
              data-testid="repairs-search-address"
              id="repairs-search-address"
            >
              {associtaedAssetList.map((e, key) => {
                return (
                  <div>
                    <div className="block">
                      <div className="text-tenancy pt-16">
                        {e.value}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div> : ""
            )}
          </div>

        {renError && (
            <Message className="error-msg">
              {t("DD_Unsuccess")} {" "}
              <button
                className="underline cursor-pointer"
                onKeyDown={openDialer}
                onClick={openDialer}
                type={undefined}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  margin: 0,
                  font: "inherit",
                  color: "inherit",
                  cursor: "pointer",
                }}
              >
                {t("DD_Unsuccess_Mob")}
              </button>{" "}
              <span aria-hidden="true">{t("Happy_to_help")}</span>
            </Message>
          )}

          {multipleAccunt ? (
            <div className="search-addressdd">
              <select
                data-testid="viewaccount-account-address"
                value={defaultAccount}
                id="viewaccount-account"
                className="text-select option-width"
                onChange={handleChangeAccount}
              >
                {accountdetails.map((e, key) => {
                  return (
                    <option  key={key} value={e.AccountNumber}>
                      {" "}
                      {t("Account")} {e.Payref}
                    </option>
                  );
                })}
              </select>
            </div>
          ) : (
            <></>
          )}

          {getAccountAllDetails()}
        </div>
      ) : (
        <div className="SpinnerWrapper">
          <LoadingSpinner />
        </div>
      )}
    </>
  );
};

export default ViewAccount;
